import { render, staticRenderFns } from "./salesServicesDetailedSummary.vue?vue&type=template&id=0806e865&"
import script from "./salesServicesDetailedSummary.vue?vue&type=script&lang=js&"
export * from "./salesServicesDetailedSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports